import React, { useState, useEffect } from "react";
import "react-toastify/dist/ReactToastify.css";
import { useNavigate } from "react-router-dom";
import Dynamic_PR_table from "../../../../components/Dynamic_PR_table";
import { API_URL } from "../../../../constants/index";
import {
  GetServiceCaller,
  PostServiceCaller,
} from "../../../../services/serviceCaller";
import { useDispatch } from "react-redux";
import { updateNavbarHeading } from "../../../../constants/layout/store/filterSlice";

const ReferCandidateList = () => {
  const navigate = useNavigate();
  const [referList, setReferList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState("");
  const [getdataClicked, setGetdataClicked] = useState(false);
  const [filterFormData, setFilterData] = useState([]);
  const [jobTitle, setJobTitle] = useState([]);
  const [candidateList, setCandidateList] = useState([]); 
  const [skillSet, setSkillSet] = useState([]);
  const [status, setStatus] = useState([]);

  const initialFormData = {
    job_title: "",
    appliedDate: "",
    SkillSet: [],
    SubSkillSet: [],
    FirstName: "",
    LastName: "",
    FullName: "",
    Email: "",
    MobileNo: "",
    gender: "",
    DateOfBirth: "",
    otherDetails: "",
  };

  const [formData, setFormData] = useState(initialFormData);

  let filters = {
    jobTitle: 0,
    candidate: 0,
    skillSet: 0,
    status: 0,
  };
  const [filter, setFilter] = useState(filters);

  useEffect(() => {
    fetchData();
  }, [searchTerm]);

  const columns = {
    FullName: { text: "Full Name", align: "start", visible: true },
    JobTitle: { text: "Job Title", align: "start", visible: true },
    ReferralName: { text: "Referral Name", align: "start", visible: true },
    SkillSet: { text: "Skill Set", align: "start", visible: true },
    Status: { text: "Status", visible: true },
    CandidateStatusNew : { text: "Candidate status", visible: true },
    AppliedDate: { text: "Applied Date", align: "center", visible: true },
    CreatedDate: { text: "Created Date", align: "center", visible: true },
  };

  const defaultColumns = {
    FullName: true,
    JobTitle: true,
    ReferralName: true,
    SkillSet: true,
    Status: true,
    CandidateStatus: true,
    AppliedDate: true,
    CreatedDate: true,
  };

  const fetchData = async () => {
    try {
      const response = await GetServiceCaller(
        `${API_URL}refercandidate?P_JobDescriptionID=${
          filterFormData.find((o) => o.label === "Job Title")
            ? filterFormData.find((o) => o.label === "Job Title").value
            : 0
        }&P_CandidateID=${
          filterFormData.find((o) => o.label === "Candidate")
            ? filterFormData.find((o) => o.label === "Candidate").value
            : 0
        }&P_Status=${
          filterFormData.find((o) => o.label === "Status")
            ? filterFormData.find((o) => o.label === "Status").value
            : 0
        }&P_SkillSet=${
          filterFormData.find((o) => o.label === "Skill Set")
            ? filterFormData.find((o) => o.label === "Skill Set").value
            : 0
        }`
      );
      setLoading(false);

      // job title dropdown
      const jobList = response?.data?.jobTitle?.map((tech) => ({
        value: tech.VALUE,
        label: tech.TEXT,
      }));
      jobList.unshift({ value: 0, label: "Select..." });
      setJobTitle(jobList);

      // candidate dropdown
      const candidateOptions = response?.data?.headers?.map((tech) => ({
        value: tech.ID,
        label: tech.FullName,
      }));
      candidateOptions.unshift({ value: 0, label: "Select..." });
      setCandidateList(candidateOptions);

      // skill set dropdown
      const skillOptions = response?.data?.skillSet?.map((tech) => ({
        value: tech.value,
        label: tech.text,
      }));
      skillOptions.unshift({ value: 0, label: "Select..." });
      setSkillSet(skillOptions);

      // status dropdown
      const statusOptions = response?.data?.status?.map((tech) => ({
        value: tech.value,
        label: tech.text,
      }));
      statusOptions.unshift({ value: 0, label: "Select..." });
      setStatus(statusOptions);

      setReferList(response?.data?.headers);
      
    } catch (error) {
      console.error("Error fetching skills:", error);
    }
  };

  const handleDropdownChange = (selected, name) => {
    setFilter((prevState) => ({
      ...prevState,
      [name]: selected.value,
    }));
  };

  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(updateNavbarHeading("Refer Candidate List"));
  }, []);

  const HandleFilter = async () => {
    setGetdataClicked(true);
    try {
      const response = await GetServiceCaller(
        `${API_URL}refercandidate?P_JobDescriptionID=${
          filterFormData.find((o) => o.label === "Job Title")
            ? filterFormData.find((o) => o.label === "Job Title").value
            : 0
        }&P_CandidateID=${
          filterFormData.find((o) => o.label === "Candidate")
            ? filterFormData.find((o) => o.label === "Candidate").value
            : 0
        }&P_Status=${
          filterFormData.find((o) => o.label === "Status")
            ? filterFormData.find((o) => o.label === "Status").value
            : 0
        }&P_SkillSet=${
          filterFormData.find((o) => o.label === "Skill Set")
            ? filterFormData.find((o) => o.label === "Skill Set").value
            : 0
        }`
      );
      setReferList(response.data.headers);
    } catch (error) {
      console.error("Error fetching job:", error);
    }
  };

  // const handleChange = (e,name) => {
  //     const { name, value } = event.target;

  //     setFormData((prevFormData) => ({
  //         ...prevFormData,
  //         [name]: value,
  //     }));
  // };

  const formDatas = [
    { name: "Job Title", type: "Select", options: [...jobTitle] },
    { name: "Candidate", type: "Select", options: [...candidateList] },
    { name: "Skill Set", type: "Select", options: [...skillSet] },
    { name: "Status", type: "Select", options: [...status] },
  ];
  const handleGetData = () => {
    HandleFilter();
  };
  const handleChange = (e, name) => {

    setFilterData((prevFormData) => {
      // Check if the label already exists
      const existingLabelIndex = prevFormData.findIndex(
        (item) => item.label === name
      );

      // If the label exists, update its value
      if (existingLabelIndex !== -1) {
        const updatedFormData = prevFormData.map((item, index) =>
          index === existingLabelIndex
            ? { ...item, value: e.value !== undefined ? e.value : e }
            : item
        );
        return updatedFormData;
      } else {
        // If the label doesn't exist, add a new label-value pair
        return [
          ...prevFormData,
          {
            label: name,
            value: e.value !== undefined ? e.value : e, // Assuming e is an event object
          },
        ];
      }
    });
  };

  const handleEdit = (id) => {
    navigate(`/refer-candidate/edit/${id.ID}`);
  };
  const handleAdd = () => {
    navigate(`/refer-candidate/add`);
  }
  return (
    <>
        <div className="container-fluid" id="skill_section">
          <div className="container-fluid" id="skill-table-area">
            <div className="row">
              <Dynamic_PR_table
                data={referList}
                columns={columns}
                defaultColumns={defaultColumns}
                itemsPerPage={8}
                searchTerm={searchTerm}
                setSearchTerm={setSearchTerm}
                isFilterRequired={true}
                formDatas={formDatas}
                handleChange={handleChange}
                filterFormData={filterFormData}
                handleGetData={handleGetData}
                isActionRequired={true}
                isSorting={true}
                isAddNewBtnRequired={true}
                showIcon1={true}
                handleIcon1={handleEdit}
                handleAddNew={handleAdd}
                Path="/refer-candidate-edit"
                icons={{
                  Icon1: <i class="bi bi-pencil-square icons"></i>,
                }}
              />
            </div>
          </div>
        </div>

    </>
  );
};

export default ReferCandidateList;
